import React, { Component } from 'react';
import { GetActivities } from './services/getActivities'

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import 'react-bootstrap-table/css/react-bootstrap-table.css'

import Spinner from './common/Spinner'

import './styles/custom.css';

export class Activities extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            loading: true,
            selectedResult:[],
        }
    }
    componentDidMount() {
        this.loadActivityData();
    };
    loadActivityData() {
        let getActivities = new Promise((resolve, reject) => {
            GetActivities(resolve, reject)
        })
        getActivities.then((data) => {
            if (data.length > 0) {
                this.setState({
                    data: data,
                    loading: false,
                })
            }
        })
    }
    dateFormatter = (cell, row) => {
        return new Date(cell).toLocaleDateString();
    }
    resultsFormatter = (cell, row) => {
        return <a onClick={()=>this.rowOnClick(cell)}>{cell}</a>
    }
    rowOnClick = (value) => {
        this.props.handleSelectedResult(value);
    }
    render() {
        let ActivityContent
        if (!this.state.loading) {
            ActivityContent = (
                <React.Fragment >
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <a className="main-header"><i className="glyphicon glyphicon-info-sign"></i>Using the Assessment</a>
                            <button className="pull-right  headerButton" onClick={this.props.handleBackToAssement}>Back</button>
                        </div>
                        <div className="panel-body">
                            <BootstrapTable data={this.state.data} striped={true} hover condensed pagination search exportCSV>
                                <TableHeaderColumn dataField="name" isKey={true} dataSort={true}>Name</TableHeaderColumn>
                                <TableHeaderColumn dataField="ranch" dataSort={true}>Ranch</TableHeaderColumn>
                                <TableHeaderColumn dataField="address" dataSort={true}>Address</TableHeaderColumn>
                                <TableHeaderColumn dataField="date" dataSort={true} dataFormat={this.dateFormatter}>Date</TableHeaderColumn>
                                <TableHeaderColumn dataField="comment" dataSort={true}>IP</TableHeaderColumn>
                                <TableHeaderColumn dataField="results" dataFormat={this.resultsFormatter}>Results</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </React.Fragment >
            )

        }
        else {
            ActivityContent = (
                <Spinner />)
        }
        return (
            <div className="container">
                {ActivityContent}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Activities.js